enum UserActions {
  UpdateUser,
  DeleteUser,
  UpdateAuth,
  DeleteAuth,
  UpdateReady,
}

export default UserActions;
